import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { GlobalStyles, IconButton, InputAdornment } from "@mui/material";
import { Calendar, X } from "lucide-react";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

const DateTimePicker: React.FC<{
  label: string;
  date: Date | null;
  setDate: (date: Date | null | string) => void;
  maxDate?: Date;
  defaultValue?: Date;
  autoFocus?: boolean;
  ignoreTopPadding?: boolean;
}> = ({
  label,
  date,
  setDate,
  maxDate,
  defaultValue,
  autoFocus,
  ignoreTopPadding = true,
}) => {
  const screen = useScreenSize();
  return (
    <>
      {ignoreTopPadding && (
        <GlobalStyles
          styles={{
            ".MuiStack-root": {
              paddingTop: "0 !important",
              marginTop: -7,
            },
          }}
        />
      )}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DemoContainer components={["DateTimePicker"]}>
          <MobileDateTimePicker
            value={date}
            format="dd/MM/yyyy hh:mm a"
            onChange={setDate}
            label={label}
            defaultValue={defaultValue ? defaultValue : undefined}
            orientation={screen.isMobile ? "portrait" : "landscape"}
            maxDateTime={maxDate}
            slotProps={{
              textField: {
                autoFocus,
                sx: {
                  "& .MuiInputBase-root": {
                    marginTop: "8px",
                  },
                  ...(date && {
                    "& .MuiInputLabel-root": {
                      transform: "translateY(1px)",
                      fontSize: "10px",
                      marginLeft: "15px",
                    },
                  }),

                  ".MuiStack-root": {
                    paddingTop: "0 !important",
                  },
                },
                InputProps: {
                  size: "small",
                  endAdornment: (
                    <InputAdornment position="end">
                      {date && (
                        <IconButton
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            setDate(null);
                          }}
                        >
                          <X
                            style={{
                              color: "#848E9C",
                              height: "16px",
                            }}
                          />
                        </IconButton>
                      )}
                      <Calendar
                        style={{
                          color: "#848E9C",
                          height: "16px",
                        }}
                      />
                    </InputAdornment>
                  ),
                },
              },
            }}
          />
        </DemoContainer>
      </LocalizationProvider>
    </>
  );
};

export default DateTimePicker;
